import { MapPin, Phone, Mail, Clock, Smartphone, Facebook, Instagram } from 'lucide-react';
import srLogo from '@/assets/sr-logo.png';

const Footer = () => {
  return (
    <footer className="bg-neutral-800 text-white">
      <div className="container mx-auto px-4 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Company Info */}
          <div>
            <a href="/" className="bg-white rounded-lg p-4 w-fit mb-6 block hover:shadow-lg transition-shadow">
              <img 
                src={srLogo} 
                alt="SR-Zerspanung Logo" 
                width={480}
                height={252}
                loading="lazy"
                className="h-20 w-auto"
              />
            </a>
            <p className="text-white/80 mb-6">
              Ihr Partner für Express-Fertigung und kostenoptimierte Produktion in der Automatisierungstechnik.
            </p>
            <div className="flex items-center gap-4 mt-6">
              <a 
                href="https://www.facebook.com/p/SR-Zerspanung-100054403395563/?locale=de_DE" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-white/70 hover:text-primary transition-colors"
                aria-label="Facebook"
              >
                <Facebook className="w-6 h-6" />
              </a>
              <a 
                href="https://www.instagram.com/srzerspanung/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-white/70 hover:text-primary transition-colors"
                aria-label="Instagram"
              >
                <Instagram className="w-6 h-6" />
              </a>
            </div>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-heading font-bold text-lg mb-6">Kontakt</h4>
            <div className="space-y-4">
              <a href="tel:+4994669115130" className="flex items-center gap-3 text-white/70 hover:text-primary transition-colors">
                <Phone className="w-5 h-5" />
                09466 / 911 51 30
              </a>
              <a href="tel:+4915122627214" className="flex items-center gap-3 text-white/70 hover:text-primary transition-colors">
                <Smartphone className="w-5 h-5" />
                0151 / 226 272 14
              </a>
              <a href="mailto:kontakt@sr-zerspanung.de" className="flex items-center gap-3 text-white/70 hover:text-primary transition-colors">
                <Mail className="w-5 h-5" />
                kontakt@sr-zerspanung.de
              </a>
              <div className="flex items-start gap-3 text-white/70">
                <MapPin className="w-5 h-5 mt-0.5 flex-shrink-0" />
                <span>Bernbachstr. 9<br />93491 Stamsried</span>
              </div>
            </div>
          </div>

          {/* Opening Hours */}
          <div>
            <h4 className="font-heading font-bold text-lg mb-6">Öffnungszeiten</h4>
            <div className="space-y-3">
              <div className="flex items-center gap-3 text-white/70">
                <Clock className="w-5 h-5" />
                <div>
                  <p>Mo - Fr: 7:00 - 16:00</p>
                  <p className="text-[hsl(198_70%_70%)] text-sm">FastLane: Sofortkontakt</p>
                </div>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading font-bold text-lg mb-6">Quick Links</h4>
            <div className="space-y-3">
              <a href="/leistungen" className="block text-white/70 hover:text-white transition-colors">
                Leistungen
              </a>
              <a href="/#warum-wir" className="block text-white/70 hover:text-white transition-colors">
                Warum wir
              </a>
              <a href="/team" className="block text-white/70 hover:text-white transition-colors">
                Team
              </a>
              <a href="/#prozess" className="block text-white/70 hover:text-white transition-colors">
                Prozess
              </a>
              <a href="/#galerie" className="block text-white/70 hover:text-white transition-colors">
                Galerie
              </a>
              <a href="/leistungen#faq" className="block text-white/70 hover:text-white transition-colors">
                FAQ
              </a>
              <a href="/#kontakt" className="block text-white/70 hover:text-white transition-colors">
                Kontakt
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-white/70 text-sm">
            © 2026 SR-Zerspanung. Alle Rechte vorbehalten. | Design by{' '}
            <a href="https://lipalife.de/" target="_blank" rel="noopener noreferrer" className="text-[hsl(198_70%_75%)] underline hover:text-white transition-colors">
              lipalife
            </a>
          </p>
          <div className="flex gap-6 text-sm">
            <a href="/impressum" className="text-white/70 hover:text-white transition-colors">Impressum</a>
            <a href="/datenschutz" className="text-white/70 hover:text-white transition-colors">Datenschutz</a>
            <a href="/agb" className="text-white/70 hover:text-white transition-colors">AGB</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
